var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodesandbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.5566 53.3337V26.667C70.5554 25.4979 70.2468 24.3497 69.6618 23.3375C69.0767 22.3254 68.2358 21.4849 67.2233 20.9003L43.89 7.56699C42.8765 6.98187 41.7269 6.67383 40.5566 6.67383C39.3864 6.67383 38.2368 6.98187 37.2233 7.56699L13.89 20.9003C12.8775 21.4849 12.0366 22.3254 11.4515 23.3375C10.8664 24.3497 10.5578 25.4979 10.5566 26.667V53.3337C10.5578 54.5027 10.8664 55.651 11.4515 56.6631C12.0366 57.6753 12.8775 58.5158 13.89 59.1003L37.2233 72.4337C38.2368 73.0188 39.3864 73.3268 40.5566 73.3268C41.7269 73.3268 42.8765 73.0188 43.89 72.4337L67.2233 59.1003C68.2358 58.5158 69.0767 57.6753 69.6618 56.6631C70.2468 55.651 70.5554 54.5027 70.5566 53.3337Z",
    stroke: "#b91c1c",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5566 14.0332L40.5566 22.6999L55.5566 14.0332",
    stroke: "#b91c1c",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5566 65.9667V48.6667L10.5566 40",
    stroke: "#b91c1c",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5566 40L55.5566 48.6667V65.9667",
    stroke: "#b91c1c",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.457 23.1992L40.557 40.0326L69.657 23.1992",
    stroke: "#b91c1c",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5566 73.6V40",
    stroke: "#b91c1c",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodesandbox);
export default __webpack_public_path__ + "static/media/codesandbox.c185127aeff76eb15be2e77a4df42f0c.svg";
export { ForwardRef as ReactComponent };